import { render, staticRenderFns } from "./GiroModal.vue?vue&type=template&id=5b957645&scoped=true"
import script from "./GiroModal.vue?vue&type=script&lang=js"
export * from "./GiroModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b957645",
  null
  
)

export default component.exports